import type { TOC } from '@ember/component/template-only'

interface Signature {
  Element: HTMLDivElement
  Blocks: {
    default: []
  }
}

export const Lozenge: TOC<Signature> = <template>
  <div
    class="border-pink-350 text-pink-350 inline-block rounded-sm border bg-pink-100 px-1.5 py-0.5 text-xs font-semibold uppercase"
    ...attributes
  >
    {{yield}}
  </div>
</template>
